import { IApplicationState } from '../../types/redux';

export function selectIsCompareAdded(state: IApplicationState): boolean {
  return Boolean(state.compare.isAdded);
}
